import { Checkbox } from "@planningcenter/doxy-web"
import AutoSizeTextInput from "source/giving/components/AutoSizeTextInput"
import { MEMO_LINE_LENGTH_LIMIT } from "../constants"
import { useDonationFormContext } from "../hooks/useDonationFormContext"
import { Memo } from "../types"

interface MemoLineProps {
  memo: Memo
}

export function MemoLine({ memo }: MemoLineProps) {
  const { dispatch } = useDonationFormContext()

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter") {
      e.preventDefault() // prevent Enter key
    }
  }

  const handleBlur = () => {
    dispatch({
      type: "SET_MEMO_TEXT",
      memoText: memo.text.replace(/\n/g, " ").trim(),
    })
  }

  return (
    <div>
      <Checkbox
        id="donation-memo-checkbox"
        checked={memo.checked}
        label={"Add a memo"}
        onChange={(event) => {
          dispatch({
            type: "SET_MEMO_CHECKED",
            memoChecked: event.target.checked,
          })
        }}
      />
      {memo.checked && (
        <>
          <div className="mt-1">
            <AutoSizeTextInput
              id="donation-memo-input"
              value={memo.text}
              maxLength={MEMO_LINE_LENGTH_LIMIT}
              aria-label="Memo"
              onBlur={handleBlur}
              onChange={(event) => {
                dispatch({
                  type: "SET_MEMO_TEXT",
                  memoText: event.target.value,
                })
              }}
              onKeyDown={handleKeyDown}
            />
          </div>
          <p id="donation-memo-disclaimer" className="c-tint2 fs-4 mt-1">
            {memo.disclaimer}
          </p>
        </>
      )}
    </div>
  )
}
